import { useCallback, useEffect, useState } from 'react';
import supabase from '../../supabase/supabase';
import { getClientId } from '../../utils/clientIdentity';
import { MODERATION_TABLE } from './chatConstants';

export default function useModerationStatus(nickname) {
  const [restriction, setRestriction] = useState(null);

  const refreshRestriction = useCallback(async () => {
    if (!nickname) {
      setRestriction(null);
      return;
    }

    const now = new Date().toISOString();
    const clientId = getClientId();

    const { data } = await supabase
      .from(MODERATION_TABLE)
      .select('*')
      .eq('active', true)
      .or(`expires_at.is.null,expires_at.gt.${now}`)
      .or(
        `subject_client_id.eq.${clientId},subject_nickname.ilike.${nickname}`
      )
      .order('created_at', { ascending: false })
      .limit(1);

    setRestriction(data?.[0] || null);
  }, [nickname]);

  useEffect(() => {
    refreshRestriction();

    const channel = supabase
      .channel(`moderation_${getClientId()}`)
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: MODERATION_TABLE },
        refreshRestriction
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [refreshRestriction]);

  return restriction;
}